import { FileWarning } from "lucide-react";
import { Button } from "@/components/ui/button";

export function BootError({ message, onRetry }) {
  if (!message) return null;
  return (
    <div role="alert" className="bg-red-50 border border-red-200 text-red-800 px-4 py-2 rounded-sm flex items-center gap-2 text-sm mb-3" data-testid="pos-boot-error">
      <FileWarning className="w-4 h-4" aria-hidden="true" />
      <span className="flex-1">{message}</span>
      <Button type="button" size="sm" variant="outline" onClick={onRetry} className="rounded-sm h-7 text-xs">Thử lại</Button>
    </div>
  );
}
